import type { AppStrings } from './types.js';
import { plural } from './plural.js';

export const he: AppStrings = {
  // COMMON
  error_title: 'שגיאה',
  cancel: 'ביטול',
  retry: 'נסה שוב',
  back_arrow: '← חזרה',

  // ASK SCREEN
  ask_box_unavailable: 'הקופסה אינה זמינה',
  ask_box_unavailable_desc: 'הקישור אולי פג תוקף או שהבעלים סגר את הקופסה.',
  ask_create_own_box: 'צור קופסה משלך',
  ask_sent_title: 'נשלח ✅',
  ask_sent_desc: 'השאלה האנונימית שלך הגיעה לבעלים הקופסה.',
  ask_anonymous_hint: 'השאלה שלך תישלח באנונימיות.',
  ask_placeholder: 'כתוב את שאלתך…',
  ask_send: 'שלח',
  ask_sending: 'שולח…',
  ask_error_rate_limit: 'יותר מדי בקשות — המתן דקה.',
  ask_error_restart: 'אנא הפעל מחדש את Mini App.',
  ask_error_load: 'טעינת הקופסה נכשלה.',
  ask_error_send: 'שליחת השאלה נכשלה.',
  ask_error_banned: 'חסמו אותך באפליקציה.',
  ask_banned_appeal_btn: 'ערעור',
  ask_appeal_sent: 'הערעור נשלח. נבדוק אותו ידנית.',

  // AGE GATE
  age_gate_title: 'לגילאי 18+ בלבד',
  age_gate_desc:
    'אתה שולח שאלה אנונימית. היה מכבד: הטרדות, איומים, תוכן מיני הכולל קטינים וכל תוכן שמפר את החוק — אסורים. אנונימיות לא אומרת חסינות — הפרות מדווחות לצוות האחריות. בשליחת שאלה אתה מאשר שאתה בן 18+ ומסכים לכללים.',
  age_gate_confirm: 'אני בן/בת 18+ — המשך',

  // INBOX SCREEN
  inbox_title: 'הקופסה שלך',
  box_link_accordion: 'קישור הזמנה',
  inbox_notifications_ask: '🔔 לאפשר לבוט לשלוח התראות על שאלות חדשות?',
  inbox_notifications_allow: 'אפשר',
  inbox_notifications_dismiss_label: 'סגור',
  inbox_box_toggle_disable: 'כבה שאלות',
  inbox_box_toggle_enable: 'הפעל שאלות',
  inbox_box_disabled_warning: 'השאלות כבויות — לא יתקבלו שאלות חדשות.',
  inbox_share_hint: 'שתף את הקישור כדי שחברים יוכלו לשאול אותך שאלות אנונימיות.',
  inbox_copy: 'העתק',
  inbox_copied: 'הועתק',
  inbox_copy_error: 'שגיאה',
  inbox_no_deeplink: 'הקישור יופיע לאחר הפריסה.',
  inbox_invite_story: 'הזמן דרך Story',
  inbox_invite_chat: 'הזמן דרך צ׳אט',
  inbox_card_rendering: 'כרטיס ההזמנה עדיין מעובד.',
  inbox_story_unsupported:
    'Stories אינם זמינים בגרסה זו של Telegram. נסה "דרך צ׳אט".',
  inbox_story_error: 'פתיחת Story נכשלה.',
  inbox_chat_unsupported:
    'שיתוף בצ׳אט אינו זמין בגרסה זו של Telegram. עדכן את הלקוח שלך.',
  inbox_chat_error: 'השיתוף נכשל. נסה שוב.',
  inbox_chat_prepare_error: 'הכנת ההזמנה נכשלה.',
  inbox_filter_incoming: 'נכנסות',
  inbox_filter_hidden: 'מוסתרות',
  inbox_filter_blocked: 'חסומות',
  inbox_filter_empty: 'אין כאן עדיין כלום.',
  inbox_acc_unanswered: 'ללא תשובה',
  inbox_acc_answered: 'נענו',
  inbox_acc_hidden: 'מוסתרות',
  inbox_acc_blocked: 'חסומות',
  inbox_empty: 'אין שאלות עדיין. שתף את הקישור למעלה.',
  inbox_load_more: 'טען עוד',
  inbox_load_more_error: 'טעינת הדף הבא נכשלה.',
  inbox_error_load: 'טעינת הקופסה נכשלה.',
  inbox_rate_limit: 'יותר מדי בקשות — המתן דקה.',
  inbox_toggle_error: 'שינוי מצב הקופסה נכשל.',

  // MESSAGE BOX (Трек D)
  message_tagline: 'כתוב לי באנונימיות',
  message_placeholder: 'כתוב הודעה…',
  message_anonymous_hint: 'ההודעה שלך תישלח באנונימיות.',
  message_sent_title: 'נשלח ✅',
  message_sent_desc: 'ההודעה האנונימית שלך נמסרה.',
  message_owner_entry: 'כתוב לי',
  message_share_hint: 'שתף את הקישור כדי שכל אחד יוכל לשלוח לך הודעה אנונימית.',
  message_inbox_open: 'הודעות שהתקבלו',
  message_inbox_title: 'הודעות',
  message_inbox_empty: 'עדיין אין הודעות. שתף את הקישור שלך למעלה.',

  // ANSWER SCREEN
  answer_title: 'ענה על השאלה',
  answer_placeholder: 'כתוב את תשובתך…',
  answer_submit: 'שלח',
  answer_submitting: 'שולח…',
  answer_back: 'חזרה',
  answer_error_send: 'שליחת התשובה נכשלה.',

  // SHARE SCREEN
  share_title: 'התשובה פורסמה ✅',
  share_hint: 'שתף את הכרטיס ואסוף עוד שאלות.',
  share_card_rendering_desc:
    'הכרטיס עדיין מעובד. חזור לשאלות ובדוק שוב בעוד רגע — תוכל לשתף אותו ב-Story או בצ׳אט.',
  share_card_alt: 'כרטיס תשובה',
  share_story_btn: 'שתף ב-Story',
  share_story_btn_busy: 'פותח…',
  share_chat_btn: 'שתף בצ׳אט',
  share_chat_btn_busy: 'מכין…',
  share_back: 'חזרה לשאלות',
  share_story_unsupported:
    'Stories אינם זמינים בגרסה זו של Telegram. נסה "שתף בצ׳אט".',
  share_story_error: 'פתיחת Story נכשלה. נסה "שתף בצ׳אט".',
  share_chat_sent: 'ההודעה נשלחה.',
  share_chat_unsupported:
    'שיתוף בצ׳אט אינו זמין בגרסה זו של Telegram. עדכן את הלקוח שלך.',
  share_chat_error: 'השיתוף נכשל. נסה שוב.',
  share_chat_prepare_error: 'הכנת ההודעה נכשלה.',

  // LEADERBOARD SCREEN
  lb_title: 'לוח מובילים',
  lb_period_7d: '7 ימים',
  lb_period_30d: '30 ימים',
  lb_period_all: 'כל הזמנים',
  lb_group_label: 'קטגוריה',
  lb_group_all: 'הכל',
  lb_group_ask: 'שאל',
  lb_group_rate: 'דרג',
  lb_group_confession: 'וידוי',
  lb_group_guesswho: 'נחש מי',
  lb_group_message: 'הודעות',
  lb_error: 'טעינת לוח המובילים נכשלה',
  lb_empty: 'אין עדיין אף אחד בדירוג',
  lb_anon: 'אנונימי',
  lb_load_more: 'טען עוד',
  lb_questions: (n) =>
    plural('he', n, {
      one: 'שאלה אחת',
      other: '{n} שאלות',
    }),
  lb_referrals: (n) =>
    plural('he', n, {
      one: 'הפניה אחת',
      other: '{n} הפניות',
    }),

  // REWARDS SCREEN
  rw_title: 'הפרסים שלי',
  rw_error: 'טעינת הפרסים נכשלה',
  rw_level: (n) => `רמה ${n}`,
  rw_confirmed_referrals: (n) =>
    plural('he', n, {
      one: 'הפניה מאושרת אחת',
      other: '{n} הפניות מאושרות',
    }),
  rw_next_level_section: (n) =>
    plural('he', n, {
      one: 'רמה הבאה — הפניה אחת',
      other: 'רמה הבאה — {n} הפניות',
    }),
  rw_to_level: (level, target) => `לרמה ${level}: ${target}`,
  rw_max_level: 'הגעת לרמה המקסימלית!',
  rw_badges_section: 'עיטורים',
  rw_formats_section: 'פורמטי קופסה',

  // QUESTION CARD
  qcard_status_new: 'חדש',
  qcard_status_hidden: 'מוסתר',
  qcard_status_answered: 'נענה',
  qcard_moderation_flagged: 'זהירות: הודעה חשודה',
  qcard_answer_btn: 'ענה',
  qcard_answer_send: 'שלח',
  qcard_share_btn: 'שתף',
  qcard_hide_btn: 'הסתר',
  qcard_show_btn: 'הצג',
  qcard_report_btn: 'דווח',
  qcard_block_btn: 'חסום',
  qcard_unblock_btn: 'בטל חסימה',
  qcard_report_reason_label: 'בחר סיבה לדיווח:',
  qcard_reason_spam: 'ספאם',
  qcard_reason_harassment: 'הטרדה',
  qcard_reason_sexual: 'תוכן מיני',
  qcard_reason_other: 'אחר',
  qcard_error_hide: 'שינוי הנראות נכשל.',
  qcard_error_report: 'שליחת הדיווח נכשלה.',
  qcard_error_block: 'חסימת השולח נכשלה.',
  qcard_report_done: 'הדיווח נשלח — תודה.',
  qcard_block_done: 'השולח נחסם.',
  qcard_unblock_done: 'חסימת השולח בוטלה.',

  // ERRORS
  err_network: 'אין חיבור לשרת. בדוק את האינטרנט ונסה שוב.',
  err_server_unavailable: 'השרת זמנית אינו זמין, נסה שוב מאוחר יותר.',
  err_internal: 'משהו השתבש אצלנו. אנו כבר בודקים — נסה שוב מאוחר יותר.',
  err_bad_request: 'אנא בדוק את הנתונים שהזנת.',
  err_generic: 'לא ניתן היה להשלים את הפעולה, נסה שוב מאוחר יותר.',
  err_schema: 'שגיאת נתונים. נסה לעדכן את האפליקציה.',
  share_story_link_premium_note:
    'קישור לחיץ ב-Stories מחייב Telegram Premium. בלעדיו חבריך עדיין יוכלו למצוא אותך — שם המשתמש שלך מוצג על הכרטיס.',

  // AUTH ERROR SCREEN
  auth_error_title: 'שגיאת גישה',
  auth_error_desc:
    'האימות נכשל. אנא סגור ופתח מחדש את Mini App מתוך Telegram.',

  // REWARD TOAST
  reward_toast_title: 'פרס חדש!',
  reward_toast_close: '×',

  // BOTTOM TABBAR
  tab_questions: 'שאלות',
  tab_leaderboard: 'מובילים',
  tab_rewards: 'פרסים',
  tab_settings: 'הגדרות',

  // SETTINGS SCREEN
  settings_title: 'הגדרות',
  settings_section_general: 'כללי',
  settings_notifications: 'התראות על שאלות חדשות',
  settings_notifications_hint: 'הבוט ישלח לך הודעה כשמישהו ישאל שאלה.',
  settings_notifications_error: 'שמירת הגדרת ההתראות נכשלה.',
  settings_language: 'שפה',
  settings_language_error: 'לא ניתן היה לשנות שפה. נסה שוב.',
  settings_section_about: 'אודות',
  settings_version: 'גרסה',

  // CODE ENTRY
  code_modal_title: 'קישורי Story זמינים ל-Premium בלבד',
  code_modal_explain:
    'Telegram נותן קישור לחיץ ב-Story רק למנויי Premium. במקום זאת הוסף את הקוד שלך ל-Story — המבקרים יקלידו אותו באפליקציה וישאלו אותך שאלה אנונימית.',
  code_modal_your_code: 'הקוד שלך',
  code_modal_copy: 'העתק קוד',
  code_modal_copied: 'הועתק',
  code_modal_share_btn: 'שתף ב-Story',
  code_modal_loading: 'מאחזר את הקוד שלך…',
  code_modal_error: 'לא ניתן היה לאחזר את הקוד שלך. נסה שוב מאוחר יותר.',
  ask_code_title: 'הכנס קוד',
  ask_code_desc:
    'הגעת מ-Story? מצא את הקוד שם (למשל 1234) והקלד למטה.',
  ask_code_placeholder: 'קוד מה-Story',
  ask_code_find: 'חפש',
  ask_code_not_found: 'הקוד לא נמצא. בדוק את הספרות ונסה שוב.',
  ask_code_invalid: 'הקוד מורכב מ-4 ספרות.',
  code_onboarding_header: 'הגעת מ-Story?',
  code_onboarding_text: 'הכנס את הקוד של חבר כדי לשאול אותו שאלה אנונימית.',
  code_onboarding_action: 'הכנס קוד',
  settings_ask_by_code: 'שאל לפי קוד',
  settings_my_code_title: 'הקוד שלך ל-Story',
  settings_my_code_hint:
    'כתוב את הקוד הזה ב-Story שלך — המבקרים יקלידו אותו כדי לשאול אותך שאלה אנונימית. Telegram נותן קישורים לחיצים ב-Story רק למנויי Premium.',
  settings_my_code_rotate: 'קבל קוד חדש',
  settings_my_code_rotating: 'מעדכן…',
  settings_my_code_done: 'הקוד עודכן',
  settings_my_code_error: 'לא ניתן היה לאחזר את הקוד שלך.',
  settings_my_code_rotate_confirm_title: 'להחליף את הקוד?',
  settings_my_code_rotate_confirm_desc:
    'הקוד הישן שלך יפסיק לעבוד מיד. מי שראה אותו ב-Story שלך כבר לא יוכל לפנות אליך. תחליף אותו רק אם מישהו מציף אותך בהודעות.',
  settings_my_code_rotate_confirm_action: 'החלפת קוד',

  // BOT
  bot_greeting: (name) => (name ? `שלום, ${name}! 👋` : 'שלום! 👋'),
  bot_onboarding:
    'זה VeylMe — שאלות אנונימיות.\n\n' +
    'פתח את Mini App, פרסם כרטיס «שאל אותי אנונימית» ב-Story שלך — ' +
    'וקבל שאלות אנונימיות ישירות כאן.\n\n' +
    '⚠️ 18+. היה מכבד: בריונות, איומים ותוכן אסור ' +
    'אינם מותרים. אנונימיות ≠ חסינות — הפרות מועברות למנהלים.',
  bot_open_btn: 'פתח את VeylMe',
  notify_answer_btn: 'השב',
  bot_invite_text:
    'מישהו שיתף קישור VeylMe.\n\n' +
    'פתח את Mini App כדי לשאול שאלה אנונימית:',
  bot_invite_btn: 'שאל אנונימית',

  // WORK-027 i18n sweep
  tagline: 'שאל אותי באנונימיות',
  share_ask_action: 'שאל',
  share_answered_text: 'עניתי על שאלה אנונימית 👀',
  err_not_in_telegram: 'Mini App אינו פועל בתוך Telegram. אנא הפעל מחדש את האפליקציה.',
  badge_viral_starter: 'התחלה ויראלית',
  badge_storyteller: 'מספר סיפורים',
  badge_loop_master: 'אלוף המעגל',
  theme_confession: 'וידויים',
  theme_guesswho: 'נחש מי',
  rw_format_named: (name) => `פורמט «${name}»`,
  card_label_question: 'שאלה',
  card_label_answer: 'תשובה',
  card_invite_subtitle: 'אנונימי, ללא הרשמה',
  card_code_hint: 'הזן את הקוד באפליקציה',
  share_msg_title: (brand) => `${brand} · שאלות אנונימיות`,
  notify_new_question: '🔔 מישהו שאל אותך שאלה אנונימית',
  notify_unanswered_reminder: (n) =>
    plural('he', n, {
      one: '🔔 יש לך שאלה אחת ללא מענה',
      other: '🔔 יש לך {n} שאלות ללא מענה',
    }),
  notify_ban_permanent: 'לצמיתות',
  notify_ban_until: (date) => `עד ${date}`,
  notify_ban_msg: (untilPhrase) =>
    `⛔ נחסמת ב-VeylMe ${untilPhrase}. יותר מדי נמענים דיווחו על ההודעות שלך.\nאם לדעתך זו טעות, תוכל להגיש ערעור באפליקציה.`,
  notify_warning_msg:
    '⚠️ כמה נמענים דיווחו על ההודעות שלך. עוד קצת ותיחסם ב-VeylMe.',

  // MY QUESTIONS SCREEN + InvitePanel non-premium hint (retention-answer-loop)
  my_questions_title: 'השאלות שלי',
  my_questions_empty_title: 'עדיין לא שאלת שאלה',
  my_questions_empty_desc: 'שאל שאלה בתיבה של מישהו — התשובה תופיע כאן.',
  my_questions_loading: 'בודקים אם יש תשובה…',
  my_questions_waiting: 'ממתין לתשובה',
  my_questions_answer_label: 'תשובה',
  settings_my_questions: 'השאלות שלי',
  ask_sent_find_reply_hint: 'תוכל למצוא את התשובה מאוחר יותר תחת «השאלות שלי».',
  inbox_story_nonpremium_hint: 'קישור לסטורי אינו לחיץ ללא Telegram Premium, לכן מוצג קוד — שיתוף בצ\'אט אמין יותר.',

  // SESSION EXPIRY SCREEN (work-038)
  session_expired_title: 'אישור הכניסה של Telegram פג',
  session_expired_desc: 'Telegram נותן לאפליקציה אישור פעם אחת בלבד, בהפעלה, והאישור הזה כבר פג. פתח את האפליקציה מחדש — את הטקסט שהתחלת שמרנו.',
  session_expired_desc_no_storage: 'האישור מ-Telegram פג, וצריך לפתוח את האפליקציה מחדש. לא הצלחנו לשמור את הטקסט שכתבת — העתק אותו לפני שאתה יוצא.',
  session_expired_reopen: 'פתח מחדש',
  session_expired_stuck_title: 'Telegram החזיר את אותו אישור ישן',
  session_expired_stuck_desc: 'סגור את האפליקציה לגמרי מתפריט הבוט ופתח אותה שוב — אז Telegram ייתן אישור חדש.',
  session_auth_failed_title: 'לא הצלחנו לאמת את הכניסה',
  session_auth_failed_desc: 'Telegram לא אימת את הכניסה שלך לאפליקציה. סגור את האפליקציה ופתח אותה מחדש מהצ\'אט עם הבוט.',
  session_expired_manual_close: 'האפליקציה לא יכולה לסגור את עצמה מכאן — סגור אותה בעצמך ופתח מחדש מהצ\'אט עם הבוט.',
  session_expiring_soon: 'אישור הכניסה של Telegram יפוג בקרוב. פתח את האפליקציה מחדש כדי ששום דבר לא ילך לאיבוד.',
  my_questions_check_failed: 'לא הצלחנו לבדוק אם יש תשובות. נסה שוב מאוחר יותר.',
  settings_notifications_load_error: 'לא הצלחנו לטעון את ההגדרה.',
};
